<template>
<!--  @click="handleClickEvent"-->
  <div
    :class="getCss('footer-download')"
    :style="{backgroundColor: configurationData.backgroundColor,...iosFullScreenExtraStyle,
    display:this.styles.base.display}"
    @click="handleClickEvent"
  >
<!--  begin   显示合规 -->
    <template v-if="configurationData.openCopyRight && !isAccessBook">
    <c-copyright
      :configuration-data="{gid:configurationData.gid,
          color: '#E6D3A4',
          backgroundColor: '#000000',
          policyColor: '#E6D3A4',
          opacity: '0.4',
    }"
      :events="events"
    ></c-copyright>
      </template>


    <!--       预约模式-->
    <template v-if="isAccessBook === true">
      <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
      <!--      预约样式 -->
      <!--      已预约样式 -->
    </template>
    <!--   begin    弹框绑定手机-->
    <CTgclubGameOrderBindPhonePop  v-model="hasAccessBindPhone"
                                   v-bind="$props"
                                   :subscriptionData="subscriptionData"
                                   @closeBindOrderPhone="closeBindOrderPhoneFunc"/>
    <!--   end    弹框绑定手机-->


    <!--  end   显示合规 -->
    <div :style="{backgroundColor: configurationData.backgroundColor,
      '--backgroundProcessBg':configurationData.processColor}"
         v-show="isAccessBook === false"
         @click="clickDownLoad" >
      <a v-show="UnDownloadStatus" href="javascript:;" class="actModules_actionBtn undownload" >
        <p class="down-rightnow">腾讯认证正版 点击下载</p>
        <p class="actModules_actionBtnTips">成功下载安装游戏可领心悦专属好礼</p>
      </a>
      <a  v-show="startGameStatus" href="javascript:;" class="actModules_actionBtn installed">
        <p >启动游戏</p>
      </a>

      <a
        v-show="readyInstallGameStatus"
        href="javascript:;" class="actModules_actionBtn finish">
        <p>腾讯认证正版 点击安装</p>
      </a>
      <a
        v-show="showProcessDownloading"
          href="javascript:;"
        class="actModules_actionBtn download-progress"
      >
        <div :class="getCss('actModules_DownLoadBar')"
             ref="downloadProgressBar"
             :style="progressStyle"
        ></div>
        <div class="download-progress-detail">
          <p>
            <span :class="getCss('download-progress-download')">
             <span  >正在下载</span>
            <span :class="getCss('download-progress-text')" v-text="downloadProgress"></span>%
            </span>
                <span :class="getCss('download-progress-size-area')">
             <span :class="getCss('download-progress-size')"  v-text="downloadSize"></span>
            <span :class="getCss('download-progress-size-separate')" >/</span>
            <span :class="getCss('download-progress-size')"  v-text="totalDownloadSize"></span>
              <span>M</span>
                </span>
          </p>
        </div>
      </a>

      <a
        v-show="showProcessDownloadPause"
        href="javascript:;"
        class="actModules_actionBtn  download-progress"
      >
        <div :class="getCss('actModules_DownLoadBar')"
             ref="downloadProgressBar"
             :style="progressStyle"
        ></div>
        <div class="download-progress-detail">
          <p>
            <span :class="getCss('download-progress-download')">
             <span  >暂停下载</span>
            <span :class="getCss('download-progress-text')" v-text="downloadProgress"></span>%
            </span>
            <span :class="getCss('download-progress-size-area')">
             <span :class="getCss('download-progress-size')"  v-text="downloadSize"></span>
            <span :class="getCss('download-progress-size-separate')" >/</span>
            <span :class="getCss('download-progress-size')"  v-text="totalDownloadSize">></span>
              <span>M</span>
                </span>
          </p>
        </div>
      </a>

    </div>

    <div class="_isoDownLoadTrips" id="_isoDownLoadTripsTarget"
        v-if="showIosCallAppStoreTrips"
        style=" display: block;
            position: fixed;
            color: #fff;
            background-color: rgba(0,0,0,0.8);
            height: 0.52rem;
            left: 50%;
            transform: translateX(-50%);
            bottom: 2rem;
            line-height: 0.52rem;
            padding: 0 0.3rem;
            border-radius: 0.1rem;
            text-align: center;
            font-size: 0.25rem;">
      正在努力加载中
      <span class="_isoDownLoadTripsPoint"
        style="display: inline-block;
        max-width: 0.23rem;
        width: 0.23rem;
        text-align: left;"
    >{{ellipsis}}</span></div>

  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import copyright from '@tencent/ceiba-act-public-copyright';
import misc from './misc.js';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import CTgclubGameOrderBindPhonePop from '@tencent/ceiba-act-tgclub-game-order-bind-phone-pop';
// import CTgclubGameOrderBindPhonePop from '../tgclub-game-order-bind-phone-pop';
// import { TgclubApi } from '../ceiba-tgclub-base-components';
import { TgclubApi } from '@tencent/ceiba-tgclub-base-components';
// 下载状态
const Undownload = 0;
const Waitting = 1;
const Downloading = 2;
const Pause = 3;
const Finish = 4;
const Fail = 5;
const Cancel = 6;
const Installed = 99;
export default {
  name: 'CTgclubFooterDownload',
  components: {
    [copyright.name]: copyright,
    [button.name]: button,
    [CDialog.name]: CDialog,
    [CTgclubGameOrderBindPhonePop.name]: CTgclubGameOrderBindPhonePop,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-footer-download-',
      gameInfo: {},
      downloadState: 0,
      downloadProgress: 0,
      downloadSize: 0,
      totalDownloadSize: 0,
      init: false,
      showIosCallAppStoreTrips: false,
      ellipsis: '',
      // 是否已经预约
      hasGameBook: false,
      hasAccessBindPhone: false,
      showProcessDownloadPause: false,
      showProcessDownloading: false,
      subscriptionData: {
        mobile: '', // 已经预约的手机
        isFocusOn: false, // 是否关注公众号
        switchStatus: 1, // 短信通知状态
        gid: 0,
        nickname: '',
      },
      isCheckTimeLimitDownload: 0, // 1 不能下载时间受限   2 可以下载
    };
  },
  computed: {

    // isAccess 是否进入预约模式
    isAccessBook() {
      const { openBook = false } = this.configurationData;
      if (openBook === false) return false;
      if (this.endGameBookTime
        && misc.getTimeStamp()  <= misc.getTimeStamp(this.endGameBookTime)) {
        return true;
      }
      return  false;
    },
    computedStyle() {
      const { bookImage, bookDoneImage } = this.configurationData;
      return {
        height: '1.28rem',
        cursor: 'pointer',
        position: 'static',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${this.hasGameBook === false ? bookImage :  bookDoneImage})`,
      };
    },
    progressStyle() {
      return {
        width: `${this.downloadProgress}%`,
        backgroundColor: this.configurationData.processColor,
      };
    },
    isIOS() {
      return this.$platform.isIos;
    },
    isAndroid() {
      return this.$platform.isAndroid;
    },
    isApp() {
      return this.$ast.isAPP();
    },
    readyInstallGameStatus() {
      return this.downloadState === Finish;
    },
    UnDownloadStatus() {
      return this.downloadState === Undownload ||   this.isIOS
        || this.downloadState === Fail || this.downloadState === Cancel;
    },
    startGameStatus() {
      return  this.downloadState === Installed ;
    },
    // downloadStateName() {
    //   return DownloadStateMap[this.downloadState] ? DownloadStateMap[this.downloadState] : '正在下载';
    // },
    H5IOSDownLoadHandle() {
      return  this.configurationData.H5IOS || 1;
    },
    H5AndroidDownLoadHandle() {
      return  this.configurationData.H5Android || 1;
    },
    // 开始下载时间
    startDownLoadTime() {
      return  this.configurationData.startDownLoadTime || '';
    },
    noneStartDownLoadMsg() {
      return  this.configurationData.noneStartDownLoadMsg || '';
    },
    endGameBookTime() {
      return this.configurationData.endGameBookTime || '';
    },
    // ios 触摸屏 底部的有一个横条  需要额外撑大底部空间
    iosFullScreenExtraStyle() {
      if (this.isAccessBook) return  {};
      const { screen } = window;
      if (this.isIOS && screen.height >= 812 &&  screen.width >= 375) {
        return {
          boxSizing: 'content-box',
          paddingBottom: '0.25rem',
        };
      }
      return {};
    },


  },
  mounted() {
    console.log('configurationData= tgclub download game ', this.configurationData);
    console.log(' styles tgclub download  ', this.styles);
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.$isInEditor) return;
      if (this.isAccessBook) {
        this.initGameBookStatus();
        this.asyncGameBookStatus();
      } else {
        this.initGameInfo();
      }
    },

    async initGameBookStatus() {
      const {  gid, autoBook = false, mustAppBook = true } = this.configurationData;
      this.$onLogined(async () => {
        const res = await  TgclubApi.queryUserSubscription(parseInt(gid, 10));
        if (res === false) {
          this.hasGameBook = false;
          if (autoBook) {
            // 在app 内自动预约
            if (mustAppBook && this.isApp) {
              this.doGameBook();
            }
            // H5 自动预约
            if (!mustAppBook) {
              this.doGameBook();
            }
          }
        } else if (res === true) {
          this.hasGameBook = true;
        }
      });
      this.$refs.button.setClickHandler(this.doGameBook, {
        forceApp: this.configurationData.mustAppBook,
        forceLogin: true,
        forceRole: false,
      });
    },
    // 获取预约
    async doGameBook() {
      const { bookFlowId } = this.configurationData;
      if (this.hasGameBook === true) return;
      const response = await this.flowRequest({
        flowId: bookFlowId,
      });
      const { ret, msg, data = {} } = response || {};
      console.log('do book action response ', response);

      if (ret !== 0) {
        this.reportOrderFunc('0', false);
        return  this.$alert({ msg });
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet !== 0) {
        this.reportOrderFunc('0', false);
        return  this.$alert({  msg: resMsg  || '预约失败' });
      }
      this.hasGameBook = true;
      this.callBack();
      // switchStatus 0 打开 1 关闭
      const { mobile = '', is_focus_on: isFocusOn = false, switch_status: switchStatus = 0  } = data;
      this.subscriptionData = {
        mobile,
        isFocusOn: !!isFocusOn,
        switchStatus,
        gid: this.configurationData.gid,
        nickname: this.userInfo?.nickName ?? '',
      };
      this.hasAccessBindPhone = true;
      this.broadcastGameBookResult(true);

      return false;
    },
    async callBack() {
      const { callBackFlowId = 0 } = this.configurationData;
      console.log('run  game book callback and callBackFlowId = ', callBackFlowId);

      if (callBackFlowId > 0) {
        const response = await this.flowRequest({
          flowId: callBackFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        this.refreshQua(); // 刷新礼包
        console.log('  game book callback  response = ', response);
      }
    },
    asyncGameBookStatus() {
      this.$eventBus.$on('ceiba:custom:events:game:book:result', async ({ status }) => {
        if (status) {
          this.hasGameBook = true;
        }
      });
    },
    //  存在多个预约地方的时候  同步
    broadcastGameBookResult(val) {
      this.$eventBus.$emit('ceiba:custom:events:game:book:result', { status: val });
    },
    async accessBindPhone() {
      const { inputPhoneFlowId = 0 } = this.configurationData;
      if (inputPhoneFlowId <= 0)  return;
      this.hasAccessBindPhone = true;
    },
    async initGameInfo() {
      const { gid = 0 } =  this.configurationData;
      if (gid <= 0) return;
      const response =  await this.$axiosInstance.get(`https://wang.xinyue.qq.com/api/fly/getPkgByGid?gid=${gid}`);
      console.log('getPkgByGid response = ', response);

      if (parseInt(response.ret, 10) === 0 &&  response.info.androidDownloadUrl) {
        const data = response.info || {};
        if (!data.androidPkgName) {
          console.warn('download androidPkgName params empty ', response);
          return;
        }
        data.icon = typeof data.icon === 'string' && data.icon ? JSON.parse(data.icon) : data.icon;
        this.gameInfo.icon = !!data.icon[108] === true ? data.icon[108] : data.icon[16];
        this.gameInfo.packagename = data.androidPkgName;
        this.gameInfo.version = data.version;
        this.gameInfo.gamename = data.gameName;
        this.gameInfo.channelid = data.channelNum;
        this.gameInfo.iosurl = data.IOSDownloadUrl;
        this.gameInfo.url = data.androidDownloadUrl;
        this.gameInfo.iOSPkgName = data.iosPkgName || data.androidPkgName;
        this.gameInfo.gid = data.gid;
        this.gameInfo.gameAppID = data.ext2;
        this.gameInfo.from = '1015';
        this.gameInfo.activityId = this.$actInfo.activity_id;

        if (common.tool.getQueryparams('adreport') !== null) {
          this.gameInfo.from += `*${common.tool.getQueryparams('adreport')}`;
        }
        this.initDownloadBridge();

        this.checkDownloadState();
        this.init = true;
        misc.reportGameChanelDownloadViewShow(this.gameInfo);
        return;
      }
      console.warn('download init fail and  androidDownloadUrl is empty ', response);
    },
    reportFunc(status) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'download',
          eventData: {
            packagename: this.isIOS ?  this.gameInfo.iOSPkgName : this.gameInfo.packagename,
            game_code: this.$actInfo?.game_code ?? '',
            status,
            dversion: this.gameInfo.version,
            gchannelversion: this.gameInfo.channelid,
            apkchannel: this.gameInfo.channelid,
          },
        };
        this.reportClickRaw(params);
        console.log('reportFunc download data =', params);
      }
    },
    closeBindOrderPhoneFunc(silentlyDownRes) {
      console.log('silentlyDownRes book = ', !!silentlyDownRes);
      this.hasAccessBindPhone = false;
      this.reportOrderFunc('1', !!silentlyDownRes);
    },
    // 预约上报
    reportOrderFunc(status, silentlyDown) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'order',
          eventData: { status,  game_code: this.$actInfo?.game_code ?? '', silently_down: silentlyDown ? '1' : '0' },
        };
        this.reportClickRaw(params);
        console.log('reportFunc order data =', params);
      }
    },
    async clickDownLoad() {
      if (this.$isInEditor) return;
      if (this.isAccessBook) return ;
      if (this.startDownLoadTime && this.noneStartDownLoadMsg
        && misc.getTimeStamp()  <= misc.getTimeStamp(this.startDownLoadTime)) {
        this.$alert({ msg: this.noneStartDownLoadMsg });
        this.reportFunc('0');
        return false;
      }
      const { checkAccessPreConditionFlowId = 0 } = this.configurationData;
      if (checkAccessPreConditionFlowId > 0) {
        if (this.isCheckTimeLimitDownload ===  0) {
          const { ret, data = {} } = await this.flowRequest({
            flowId: checkAccessPreConditionFlowId,
          });
          const { ret: resRet = -1 } = data;
          if (ret === 0 && resRet === 0) {
            // 没有时间限制
            this.isCheckTimeLimitDownload =  2;
          } else {
            this.isCheckTimeLimitDownload =  1;
          }
        }
        // 错误报错  不需要下载
        if (this.isCheckTimeLimitDownload ===  1) {
          this.$alert({ msg: this.noneStartDownLoadMsg || '游戏下载时间未开放' });
          return  false;
        }
      }

      if (!this.init) return ;
      console.log('this.gameInfo = ', JSON.stringify(this.gameInfo));
      if (!this.isApp) {
        // 配置双端的现在下载方式
        return  this.handleDownloadH5();
      }
      if (!window.Tgclub) {
        return  false;
      }
      // 处理ios 下载
      if (this.isIOS) {
        this.doDownloadInIOS();
        this.reportFunc('1');
        return  false;
      }
      this.doDownloadInAndroid();
      this.reportFunc('1');
      // 根据双端展示不同的下载方式
      return  true;
    },
    getRemarkKey() {
      const { gid = 0 } = this.configurationData;
      return  `_gameDownLoadStatus_${gid}_process`;
    },
    // 触发下载进度更新
    initDownloadBridge() {
      const that = this;
      Object.defineProperty(window, this.getRemarkKey(), {
        set: (newValue) => {
          that.displayDownLoadStatus(newValue);
        },
        enumerable: true,
        configurable: true,
      });
    },
    buytesToMB(size) {
      if (!size || size === 0) return 0;
      return  (size / 1024 / 1024).toFixed(2);
    },
    // 下载状态
    displayDownLoadStatus(ret) {
      let  { totalLen = 0, receivedLen = 0 } = ret;
      const { state = 0 } = ret;
      totalLen = totalLen || 0;
      receivedLen = receivedLen || 0;
      this.downloadSize  =  this.buytesToMB(receivedLen);
      this.totalDownloadSize  =  this.buytesToMB(totalLen);
      let tempLength  = totalLen > 0 ?  (receivedLen / totalLen * 100).toFixed(2) : 0;
      tempLength  =  tempLength > 100 ? 100 : tempLength;
      if (tempLength !==  this.downloadProgress) {
        this.downloadProgress = tempLength;
      }
      // console.log(' =state =-------------- ', state);
      switch (state) {
        case 0:
          this.showProcessDownloadPause = false;
          this.showProcessDownloading = false;
          this.downloadState = Undownload;
          break;
        case 1:
          if (!this.showProcessDownloading) {
            this.showProcessDownloadPause = false;
            this.showProcessDownloading = true;
          }
          this.downloadState = Waitting;
          break;
        case 2:
          if (!this.showProcessDownloading) {
            this.showProcessDownloadPause = false;
            this.showProcessDownloading = true;
          }
          this.downloadState = Downloading;
          break;
        case 3:
          if (!this.showProcessDownloadPause) {
            this.showProcessDownloadPause = true;
            this.showProcessDownloading = false;
          }
          this.downloadState = Pause;
          break;
        case 4:
          this.showProcessDownloadPause = false;
          this.showProcessDownloading = false;
          this.downloadState = Finish;
          break;
        case 5:
          this.showProcessDownloadPause = false;
          this.showProcessDownloading = false;
          this.downloadState = Fail;
          break;
        case 6:
          this.showProcessDownloadPause = false;
          this.showProcessDownloading = false;
          this.downloadState = Cancel;
          break;
      }
    },
    async checkDownloadState() {
      // 没有下载环境不进行初始化
      if (!window.Tgclub || !this.isApp) {
        this.downloadState = Undownload;
        return true;
      }
      // ios 不需要 有下载状态
      if (this.isIOS) {
        this.downloadState = Undownload;
        return true;
      }
      const { packagename } = this.gameInfo;
      // 已近 安装
      if (misc.isInstall(packagename) && misc.isTgClubChanneID(packagename)) {
        this.downloadState = Installed;
        return true;
      }
      //  查询下载进度状态
      if (window.Tgclub && window.Tgclub.checkDownloadState) {
        let dataJson = window.Tgclub.checkDownloadState(this.gameInfo.url) || '{}';
        dataJson = JSON.parse(dataJson);
        const { state = 0 } = dataJson;
        // 下载状态初始化 同步app在下载的状态
        if (state === Waitting || state === Downloading) {
          this.startDownload();
        }
        this.displayDownLoadStatus(dataJson);
      }
    },
    // 安装游戏
    installGame() {
      window.Tgclub &&  window.Tgclub.installDownloadApp(this.gameInfo.url);
      const { packagename } = this.gameInfo;
      const that = this;
      const timeId =  setInterval(() => {
        if (misc.isInstall(packagename) && misc.isTgClubChanneID(packagename)) {
          that.downloadState = Installed;
          clearInterval(timeId);
          return true;
        }
      }, 2000);
    },
    //  拉起游戏
    callGame() {
      window.Tgclub &&  window.Tgclub.openApp(this.gameInfo.packagename);
    },
    // 暂停下载
    pauseDownload() {
      this.downloadState = Pause;
      this.showProcessDownloadPause = true;
      this.showProcessDownloading = false;
      if (window.Tgclub && window.Tgclub.stopDownloadApp) {
        window.Tgclub.stopDownloadApp(this.gameInfo.url);
      }
    },
    //  开始现在或
    startDownload() {
      this.showProcessDownloadPause = false;
      this.showProcessDownloading = true;
      const remarkKey = this.getRemarkKey();
      this.downloadState = Downloading;
      const callback = `function(ret){if(JSON.parse(ret).totalLen > 0){window.${remarkKey} = JSON.parse(ret);}}`;
      window.Tgclub.downloadApp(JSON.stringify(this.gameInfo), callback);
    },
    doDownloadInAndroid() {
      const  statusHandle =      {
        [Undownload]: this.startDownload,
        [Waitting]: this.startDownload,
        [Downloading]: this.pauseDownload,
        [Pause]: this.startDownload,
        [Finish]: this.installGame,
        [Fail]: this.startDownload,
        [Cancel]: this.startDownload,
        [Installed]: this.callGame,
      };
      const targetFunc = statusHandle[this.downloadState] ||  this.startDownload;
      targetFunc.apply(this);
    },
    // 下载ios  拉起appstore
    doDownloadInIOS() {
      this.downloadState = Undownload ;
      this.showIosDownLoadTrip();
      window.Tgclub && window.Tgclub.downloadApp(JSON.stringify(this.gameInfo));
    },
    // 下载ios 提示
    showIosDownLoadTrip() {
      let num = 0;
      const that = this;
      this.showIosCallAppStoreTrips = true;
      const showIosDownLoadTripsTimeId = setInterval(() => (function () {
        num = num + 1;
        if (num > 3) {
          num = 1;
        }
        that.ellipsis =  new Array(num).fill('.')
          .join('');
      }()), 400);
      setTimeout(() => {
        clearInterval(showIosDownLoadTripsTimeId);
        this.showIosCallAppStoreTrips = false;
      }, 3000);
    },
    // 处理双端下载
    handleDownloadH5() {
      if (this.isIOS) {
        if (this.H5IOSDownLoadHandle === 1) {
          return this.$ast.gotoAPP();
        }
        return window.location.href = this.gameInfo.iosurl;
      }
      if (this.isAndroid) {
        if (this.H5AndroidDownLoadHandle === 1) {
          return this.$ast.gotoAPP();
        }
        return this.jumpBrowserAndDownLoadApp(this.gameInfo.url);
      }
    },
    jumpBrowserAndDownLoadApp(downLoadLink) {
      if (!downLoadLink) {
        return false;
      }
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = `javascript:window.location.href='${downLoadLink}'`;
      document.getElementsByTagName('body')[0].appendChild(iframe);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';


.bottom {
  top: auto;
  background-color: #ffe45e;
}

.downloadBg {
  background-color: #ffe45e;
}

.down-rightnow {
  text-align: center;
  height: 0.5rem;
  font-size: 0.4rem;
  margin-top: 0.2rem;
  margin-bottom: 0.1rem;
  color: #000;
}

.btnBox {
  height: 1.28rem;
  width: 7.5rem;
}

.installed p,.finish p {
  height: 1.28rem;
  text-align: center;
  line-height: 1.28rem;
  font-size: 0.4rem;
}

.download-progress-detail {
  z-index: 200;
  width: 7.5rem;
  height: 1.28rem;
  text-align: center;
  line-height: 1.28rem;
  font-size: 0.4rem;
  position: absolute;
  left: 0;
  top: 0;
}

.download-progress-detail p {
  height: 0.52rem;
  line-height:0.52rem;
  text-align: center;
   margin-top : 0.38rem;
  //display:flex;
  //justify-content:center;
  //flex-wrap: nowrap;
}


.actModules_actionBtn {
  height: 1.28rem;
  width: 7.5rem;
  color: #4a4a4a;
  font-size: 0.4rem;
  box-align: center;
  box-orient: vertical;
  left: 0;
  bottom: 0;
  margin: 0 auto;
}

.actModules_actionBtnTips {
  font-size: 0.26rem;
  color: #4a4a4a;
  line-height: 1.2;
  text-align: center;
}

.actModules_DownLoadPercent {
  z-index: 10;
}
.download-progress {
  color:#ffffff;
}

</style>
